<template>
  <section class="agent-and-store-tab">
    <main class="tabs">
      <div
        :class="['tabs-item', { active: activeTab === tab.value }]"
        v-for="tab in tabs"
        :key="tab.label"
        @click="handleTabClick(tab)"
      >
        <span class="tab-label">{{ tab.label }}</span>
        <Tooltip
          v-if="tab.label.includes('我的')"
          v-model="showMineTip"
          :content="tab.tip"
          :placement="tab.tipPlacement"
        />
        <Tooltip
          v-if="tab.label.includes('门店')"
          v-model="showStoreTip"
          :content="tab.tip"
          :placement="tab.tipPlacement"
        />
      </div>
    </main>
    <footer v-if="activeTab === 'store'" class="store-display">
      <div class="store-title">
        <img src="@/assets/images/agent/storeTab/shop.png" alt="" />
        <p>
          {{ hasBindStore ? currentStore.storeName : '未绑定门店' }}
        </p>
      </div>
      <div v-if="canToggle" class="toggle-btn" @click="showStoreList">
        <p>切换</p>
        <img src="@/assets/images/agent/storeTab/toggle.png" alt="" />
      </div>
    </footer>
    <StoreListDrawer
      v-model="showStoreDrawer"
      :store-id="currentStore.storeId"
      :list="list"
      @on-change="toggleStore"
      @on-reach-bottom="loadMore"
    />
    <NoBindingStore v-if="!hasBindStore && activeTab === 'store'" />
  </section>
</template>

<script>
import { ref, computed, defineComponent } from 'vue'
import { CONFIG, generateTabs } from './data'

import { AgentStore } from './AgentStore'

import Tooltip from './Tooltip.vue'
import StoreListDrawer from './StoreListDrawer.vue'
import NoBindingStore from './NoBindingStore.vue'

export default defineComponent({
  name: 'AgentAndStoreTab',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  components: { Tooltip, StoreListDrawer, NoBindingStore },

  props: {
    transformer: {
      type: Function,
    },
    type: {
      type: String,
      required: true,
      validator: val => CONFIG[val],
    },
    modelValue: {
      type: String,
      default: 'mine',
      validator: val => ['mine', 'store'].includes(val),
    },
  },

  setup(props, ctx) {
    const showMineTip = ref(false)
    const showStoreTip = ref(false)

    const tabs = computed(() => {
      const result = generateTabs(props.type)
      if (!props.transformer) {
        return result
      } else {
        return props.transformer(result)
      }
    })

    const activeTab = computed({
      get() {
        return props.modelValue || 'mine'
      },
      set(val) {
        ctx.emit('update:modelValue', val)
      },
    })

    function handleTabClick(tab) {
      if (tab.value === activeTab.value) return
      activeTab.value = tab.value
      ctx.emit('update:modelValue', tab.value)
      ctx.emit('on-change', tab.value)
      const storeParams =
        tab.value === 'store'
          ? [as.currentStore.value?.storeId, as.currentStore.value]
          : []
      ctx.emit('on-store-change', ...storeParams)
    }

    const showStoreDrawer = ref(false)
    const as = new AgentStore({
      afterResetList: () => {
        ctx.emit('on-load', as.currentStore.value?.storeId)
      },
    })
    function showStoreList() {
      showStoreDrawer.value = true
    }

    function toggleStore(_, store) {
      showStoreDrawer.value = false
      as.setCurrentStore(store)
      ctx.emit('on-store-change', store.storeId, store)
    }

    function loadMore() {
      as.loadMore()
    }

    return {
      showMineTip,
      showStoreTip,
      tabs,
      activeTab,
      handleTabClick,
      showStoreList,
      showStoreDrawer,
      list: as.list,
      currentStore: as.currentStore,
      canToggle: as.canToggle,
      agent: as.agent,
      toggleStore,
      loadMore,
      hasBindStore: computed(() => as.currentStore.value.storeId > 0),
    }
  },
})
</script>

<style scoped lang="scss">
@import './variables.scss';
.agent-and-store-tab {
  width: 100%;

  .tabs {
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    height: $tab-height;
    border-bottom: 1px solid rgba(32, 33, 36, 0.03);
    background: #fff;
    z-index: 667;
  }

  .tabs-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 14px;
    font-size: var(--set-font-size14);
    color: #60646b;

    .tab-label {
      display: inline-block;
      height: 100%;
      line-height: 50px;
    }

    &.active {
      color: #202124;
      font-weight: bold;

      .tab-label {
        border-bottom: 2px solid #006cff;
      }
    }
  }

  .store-display {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    margin: 12px 12px 10px;
    background: #ebf4ff;
    border: 1px solid #ffffff;
    box-shadow: 0px 2 20px 0px rgba(1, 40, 111, 0.05);
    border-radius: 8px;
    z-index: 10;

    .store-title {
      display: flex;
      align-items: center;
      gap: 8px;
      img {
        width: 18px;
        height: 18px;
      }
      p {
        font-size: 12px;
        font-size: var(--set-font-size12);
        color: #01286f;
        line-height: 20px;
        font-weight: bold;
      }
    }

    .toggle-btn {
      display: flex;
      gap: 2px;
      font-size: 12px;
      font-size: var(--set-font-size12);
      color: rgba(1, 40, 111, 0.6);
      line-height: 20px;
      font-weight: bold;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
